module.exports = __webpack_public_path__ + "images/knac64a681eba1d2bcc6239b12ddca20de54.png";